export const stockwiseLoginUrl = "https://app.stockwise.io/auth/login";
export const stockwiseRegisterUrl = "https://app.stockwise.io/auth/register";
